<template>
  <v-container color="primary">
    <v-row justify="center" align="center" class="ma-0 pa-0">
      <v-col>
        <div :class="[isMobile ? 'title' : 'display-1']">АРЕНДА</div>
      </v-col>
    </v-row>

    <v-row justify="center" class="black--text" >
      <v-col  cols="12" sm="12" md="12" lg="8" xl="8">
<!--         <div class="display-1   mb-3 ">
          ЗАЯВКА НА АРЕНДУ
        </div> -->

<v-row justify="start">
  <v-col cols="12" sm="12" md="12" lg="10" xl="10" class="text-left">
  <p>Торгово-развлекательный центр «ГАГАРИНСКИЙ» - это уникальное сочетание суперокружного масштаба и центрального местоположения, которое гарантирует ему коммерческий успех.Торгово-развлекательный центр «ГАГАРИНСКИЙ» - это уникальное сочетание суперокружного масштаба и центрального местоположения, которое гарантирует ему коммерческий успех.</p>  
        <div class="title mb-3 ">
          Ключевые преимущества ТРЦ «ГАГАРИНСКИЙ»:
        </div>  
  <ul>
    <li>
      200 000 кв. метров общей площади
    </li>
    <li>
      1,5 минуты от ст. м. «Ленинский проспект»
    </li>
    <li>
      прямой заезд с ТТК и ул. Вавилова
    </li>
    <li>
      район с высокой покупательной способностью
    </li>
    <li>
      отсутствие конкуренции в первой зоне охвата
    </li>
    <li>
      высокий пешеходный и автомобильный трафик
    </li>
    <li>
      якорь: крупнейший в Европе «Ашан»
    </li>
  </ul>
        <div class="title  mb-3 ">
          По вопросам аренды помещений:
        </div>  
  <p>Телефон: <Phone :number= "`+7 (495) 730-07-59`" /> </p>
  <p>E-mail: <Email :emailaddr= "`arenda@trcgagarinsky.ru`" /></p>
        <div class="title  mb-3 ">
          Для рекламодателей:
        </div>  
  <p>Телефон: <Phone :number= "`+7 (495) 730-28-57`" /> </p>

  </v-col>
</v-row>

<v-row justify="center">
  <v-col cols="12" >
        <div class="title  mb-3 ">
          Заявка на аренду
        </div>
        <v-form ref="form">
          <v-text-field            
            placeholder="Название вашей организации"
            v-model="valNameFirm"            
            :error="errorNameFirm"
            :error-messages="errorNameFirmText"
            @blur="blurChange('1')"
          >
      <template v-slot:label>
          Полное название организации <v-icon
            small
            color="red"
            style="vertical-align: top">
            mdi-multiplication
          </v-icon>:
        </template>           
          </v-text-field>
          <v-select            
            v-model="valTradeProfile"
            :items="itemsTradeProfile"
            attach
            chips
            :error="errorTradeProfile"
            :error-messages="errorTradeProfileText"            
            @blur="blurChange('2')"            
            multiple
          >

      <template v-slot:label>
          Торговый профиль <v-icon
            small
            color="red"
            style="vertical-align: top">
            mdi-multiplication
          </v-icon>:
        </template>          
          
          </v-select>
        <v-textarea
          
          name="itemsProfile"
          label="Товарный профиль (одежда, обувь, аксессуары, товары для детей и т.п.):"
          v-model="valItemsProfile"
          rows="3"
        >
        
        </v-textarea>
        <v-textarea
          
          name="tradeMarks"
          label="Торговые марки, представляемые Вашей компанией:"
          v-model="tradeMarks"
          rows="2"
        ></v-textarea>
        <div class="subtitle  mb-3 text-left">
          Информация об открытых магазинах:
        </div>

        <v-row justify="start" align="start">
          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
            <v-text-field
              
              v-model="numberOpenedShops"
              
              label="Количество открытых магазинов:	"
              max="150"
              min="0"
              step="1"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="8" xl="8">
            <v-textarea              
              name="otherTRC"
              label="В каких ТЦ представлены:	"
              v-model="otherTRC"
              rows="2"
            ></v-textarea>
          </v-col>
        </v-row>


        <v-card class="pa-4" >


        <div class="subtitle  mb-3 text-left">
          Размер интересующей торговой площади в ТЦ (кв.м.) <v-icon
            small
            color="red"
            style="vertical-align: top">
            mdi-multiplication
          </v-icon>:
        </div> 
        <v-row justify="start" align="start">
          <v-col cols="4">
            <v-text-field
              
              v-model="squareShop.from"
              suffix="кв.м."              
              label="От	"
              max="2500"
              min="0"
              step="1"
              type="number"
              :rules="[rules.number]"
              :error="errorSquareShop_from"
              :error-messages="errorSquareShop_fromText" 
              @blur="blurChange('3')"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field              
              v-model="squareShop.to"
              suffix="кв.м."
              label="До	"
              max="2500"
              min="0"
              step="1"
              type="number"
              :rules="[rules.number]"
              :error="errorSquareShop_to"
              :error-messages="errorSquareShop_toText"               
              @blur="blurChange('4')"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field              
              v-model="squareShop.optima"
              suffix="кв.м."              
              label="Оптимальный"
              max="2500"
              min="0"
              step="1"
              type="number"
              :rules="[rules.number]"
              :error="errorSquareShop_optima"
              :error-messages="errorSquareShop_optimaText"               
              @blur="blurChange('5')"
            ></v-text-field>
          </v-col>

        </v-row>
        <div class="subtitle  mb-3 text-left">
          Включая:
        </div> 
        <v-row justify="start" align="start">
          <v-col cols="4">
            <v-text-field
              
              v-model="squareShop.includeTrade"
              suffix="кв.м."              
              label="Торговая площадь	"
              max="2500"
              min="0"
              step="1"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field              
              v-model="squareShop.includeWarehouse"
              suffix="кв.м."              
              label="Складские помещения	"
              max="2500"
              min="0"
              step="1"
              type="number"
              
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field              
              v-model="squareShop.includeOffice"
              suffix="кв.м."              
              label="Офис	"
              max="2500"
              min="0"
              step="1"
              type="number"
            ></v-text-field>
          </v-col>

        </v-row>
        </v-card>

        <v-card          
          class="pa-4 mt-6"
        >
        
        <div class="subtitle  mb-3 text-left">
          Контактная информация:
        </div> 
        <v-textarea          
          name="tradeMarks"
          label="Фактический адрес:"
          v-model="contactsArenda.address"
          rows="2"
        ></v-textarea>
        <v-textarea          
          name="tradeMarks"
          label="Контактные телефоны *:"
          v-model="contactsArenda.phones"
          :rules="[rules.phone]"
          :error="errorPhone"
          :error-messages="errorPhoneText"            
            @blur="blurChange('9')"
          rows="1"
        >
      <template v-slot:label>
          Контактные телефоны <v-icon
            small
            color="red"
            style="vertical-align: top">
            mdi-multiplication
          </v-icon>:
        </template>         
        </v-textarea>
        <v-textarea          
          name="tradeMarks"
          v-model="contactsArenda.email"
          :rules="[rules.email]"              
          :error-messages="errorEmailText"            
          :error="errorEmail"
          @blur="blurChange('10')"
          
          rows="1"
        >
      <template v-slot:label>
          E-mail <v-icon
            small
            color="red"
            style="vertical-align: top">
            mdi-multiplication
          </v-icon>:
        </template>         
        
        </v-textarea>
        <v-textarea          
          name="tradeMarks"
          label="Web-site:"
          v-model="contactsArenda.www"
          rows="1"
        ></v-textarea>
        <v-textarea          
          name="tradeMarks"
          v-model="contactsArenda.fio"          
          :error-messages="errorFioText"            
          :error="errorFio"          
          @blur="blurChange('11')"
          rows="1"
        >
      <template v-slot:label>
          ФИО и должность контактного лица <v-icon
            small
            color="red"
            style="vertical-align: top">
            mdi-multiplication
          </v-icon>:
        </template>         
        
        </v-textarea>
        </v-card>
        <v-switch          
          v-model="chkPerson"
          class="ma-1"
          :error="errorCheckPerson"  
          @blur="blurChange('12')"
        >
      <template v-slot:label>
          Я согласен(а) на обработку моих персональных данных <v-icon
            small
            color="red"
            style="vertical-align: top">
            mdi-multiplication
          </v-icon>
        </template>        
        
        </v-switch>
        </v-form>
  </v-col>
</v-row>

<v-btn @click="sendForm">Отправить анкету</v-btn>

      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbar"
      :multi-line="multiLine"
      top
    >
      {{ textSnackBar }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>

import YandexMap from '@/components/YandexMap'
import Phone from '@/components/Phone'
import Email from '@/components/Email'

import axios from "axios";

export default {
  name: 'Arenda',
  components: {
    YandexMap,
    Phone,
    Email
  },
  data: () => ({
    valNameFirm:'',
    valTradeProfile:'',
    itemsTradeProfile:['Магазин','Ресторан/Кафе','Развлечения/Услуги','Офисы'],
    valItemsProfile: '',
    tradeMarks: '',
    numberOpenedShops: '0',
    otherTRC:'',
    squareShop: {
      from:'0',
      to:'0',
      optima:'0',
      includeTrade:'0',
      includeWarehouse:'0',
      includeOffice:'0'
    },
    contactsArenda: {
      address: '',
      phones: '',
      email: '',
      www: '',
      fio: '',
    },
    chkPerson:true,
    rules: {
      required: value => !!value || 'Обязательно к заполнению.',
      counter: value => value.length <= 20 || 'Max 20 characters',
      phone: value => {
        const pattern = /^(?:\+\d{1,3}|0\d{1,3}|00\d{1,2})?(?:\s?\(\d+\))?(?:[-\/\s.]|\d)+$/
        return pattern.test(value) || 'Некорректные данные.'
      },
      number: value => {
        const pattern = /^\d+$/
        return pattern.test(value) || 'Введите только цифры.'
      },
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Некорректный e-mail.'
      },
    },
    errorNameFirm: false,
    errorTradeProfile: false,
    errorSquareShop_from: false,
    errorSquareShop_to: false,
    errorSquareShop_optima: false,
    errorSquareShop_includeTrade: false,
    errorSquareShop_includeWarehouse: false,
    errorSquareShop_includeOffice: false,
    errorEmail : false,
    errorPhone : false,
    errorFio : false,
    errorCheckPerson : false,
    errorNameFirmText:'',
    errorTradeProfileText : '',
    errorSquareShop_fromText : '',
    errorSquareShop_toText : '',
    errorSquareShop_optimaText : '',
    errorSquareShop_includeTradeText : '',
    errorSquareShop_includeWarehouseText : '',
    errorSquareShop_includeOfficeText : '',
    errorEmailText : '',
    errorPhoneText : '',
    errorFioText : '',
    snackbar: false,
    multiLine: true,
    textSnackBar: `Неверно заполнена форма. Проверьте ошибочные поля`,
    textSnackBarOkSend: `Заявка отправлена. Спасибо`,

    
  }),
        metaInfo: {
          title: 'Аренда -',

        },

computed:{
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },  
      isMobile: {
      get () {
        return this.$store.state.app.isMobile
      }
      
    },
        titleInnert: {
          get () {
            if(DEBUG) console.log('this.$store.state.category :', this.$store.state.app.titleInner);
            return this.$store.state.app.titleInner;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setTitleInner', val)
          }
        }
},
methods:{
  blurChange(itemName){
    const vApp = this
    if(DEBUG) console.log('itemName :>> ', itemName);
    switch (itemName) {
      case '1':
        if( vApp.valNameFirm !=='') {
          vApp.errorNameFirm = false
          vApp.errorNameFirmText=''
        }
        else{
          vApp.errorNameFirm = true
          vApp.errorNameFirmText='Поле обязательно к заполнению!'          
        }
        break;
      case '2':
        if(DEBUG) console.log('vApp.valTradeProfile :>> ', vApp.valTradeProfile.length);
        if( vApp.valTradeProfile.length!== 0) {
          vApp.errorTradeProfile = false
          vApp.errorTradeProfileText=''
        }
        else{
          vApp.errorTradeProfile = true
          vApp.errorTradeProfileText='Поле обязательно к заполнению!'          
        }
        break;
      case '3':
        if(DEBUG) console.log('vApp.valTradeProfile :>> ', vApp.squareShop.from);
        if( vApp.squareShop.from > 0) {
          vApp.errorSquareShop_from = false
          vApp.errorSquareShop_fromText=''
        }
        else{
          vApp.errorSquareShop_from = true
          vApp.errorSquareShop_fromText='Поле обязательно к заполнению!'          
        }
        break;
      case '4':
        if(DEBUG) console.log('vApp.squareShop.to :>> ', vApp.squareShop.to);
        if( vApp.squareShop.to > 0) {
          vApp.errorSquareShop_to = false
          vApp.errorSquareShop_toText=''
        }
        else{
          vApp.errorSquareShop_to = true
          vApp.errorSquareShop_toText='Поле обязательно к заполнению!'          
        }
        break;
      case '5':
        if(DEBUG) console.log('vApp.squareShop.optima :>> ', vApp.squareShop.optima);
        if( vApp.squareShop.optima > 0) {
          vApp.errorSquareShop_optima = false
          vApp.errorSquareShop_optimaText=''
        }
        else{
          vApp.errorSquareShop_optima = true
          vApp.errorSquareShop_optimaText='Поле обязательно к заполнению!'          
        }
        break;
/*      case '6':
        if(DEBUG) console.log('vApp.squareShop.includeTrade :>> ', vApp.squareShop.includeTrade);
        if( vApp.squareShop.includeTrade > 0) {
          vApp.errorSquareShop_includeTrade = false
          vApp.errorSquareShop_includeTradeText=''
        }
        else{
          vApp.errorSquareShop_includeTrade = true
          vApp.errorSquareShop_includeTradeText='Поле обязательно к заполнению!'          
        }
        break;
      case '7':
        if(DEBUG) console.log('vApp.squareShop.includeWarehouse :>> ', vApp.squareShop.includeWarehouse);
        if( vApp.squareShop.includeWarehouse > 0) {
          vApp.errorSquareShop_includeWarehouse = false
          vApp.errorSquareShop_includeWarehouseText=''
        }
        else{
          vApp.errorSquareShop_includeWarehouse = true
          vApp.errorSquareShop_includeWarehouseText='Поле обязательно к заполнению!'          
        }
        break;
       case '8':
        if(DEBUG) console.log('vApp.squareShop.includeOffice :>> ', vApp.squareShop.includeOffice);
        if( vApp.squareShop.includeOffice > 0) {
          vApp.errorSquareShop_includeOffice = false
          vApp.errorSquareShop_includeOfficeText=''
        }
        else{
          vApp.errorSquareShop_includeOffice = true
          vApp.errorSquareShop_includeOfficeText='Поле обязательно к заполнению!'          
        }
        break; */
      case '9':
        if(DEBUG) console.log('vApp.contactsArenda.phones :>> ', vApp.contactsArenda.phones);
        if( vApp.contactsArenda.phones !== '') {
          vApp.errorPhone = false
          vApp.errorPhoneText=''
        }
        else{
          vApp.errorPhone = true
          vApp.errorPhoneText='Поле обязательно к заполнению!'          
        }
        break;
      case '10':
        if(DEBUG) console.log('vApp.contactsArenda.email :>> ', vApp.contactsArenda.email);
        if( vApp.contactsArenda.email !== '') {
          vApp.errorEmail = false
          vApp.errorEmailText=''
        }
        else{
          vApp.errorEmail = true
          vApp.errorEmailText='Поле обязательно к заполнению!'          
        }
        break;
      case '11':
        if(DEBUG) console.log('vApp.contactsArenda.fio :>> ', vApp.contactsArenda.fio);
        if( vApp.contactsArenda.fio !== '') {
          vApp.errorFio = false
          vApp.errorFioText=''
        }
        else{
          vApp.errorFio = true
          vApp.errorFioText='Поле обязательно к заполнению!'          
        }
        break;
      case '12':
        if(DEBUG) console.log('vApp.contactsArenda.fio :>> ', vApp.chkPerson);
        if( vApp.chkPerson) {
          vApp.errorCheckPerson = false
          //vApp.errorFioText=''
        }
        else{
          vApp.errorCheckPerson = true
          //vApp.errorFioText='Поле обязательно к заполнению!'          
        }
        break;


      default:
        break;
    }    

  },
sendForm(){
  const vApp = this;
  if(DEBUG) console.log('send Form :>> ');
  if(vApp.valNameFirm ===''){
    vApp.errorNameFirm = true
    vApp.errorNameFirmText = 'Поле обязательное к заполнению'
    vApp.textSnackBar= `Неверно заполнена форма. Проверьте ошибочные поля`
    vApp.snackbar=true
    return
  }
  else{
    vApp.errorNameFirm = false
    vApp.errorNameFirmText = ''
  }
    


        if( vApp.valTradeProfile.length!== 0) {
          vApp.errorTradeProfile = false
          vApp.errorTradeProfileText=''
        }
        else{
          vApp.errorTradeProfile = true
          vApp.errorTradeProfileText='Поле обязательно к заполнению!'
          vApp.textSnackBar= `Неверно заполнена форма. Проверьте ошибочные поля`
          vApp.snackbar=true
          return
        }

        if( vApp.squareShop.from > 0) {
          vApp.errorSquareShop_from = false
          vApp.errorSquareShop_fromText=''
        }
        else{
          vApp.errorSquareShop_from = true
          vApp.errorSquareShop_fromText='Поле обязательно к заполнению!'
          vApp.textSnackBar= `Неверно заполнена форма. Проверьте ошибочные поля`
          vApp.snackbar=true
          return
        }

        if( vApp.squareShop.to > 0) {
          vApp.errorSquareShop_to = false
          vApp.errorSquareShop_toText=''
        }
        else{
          vApp.errorSquareShop_to = true
          vApp.errorSquareShop_toText='Поле обязательно к заполнению!' 
          vApp.textSnackBar= `Неверно заполнена форма. Проверьте ошибочные поля`         
          vApp.snackbar=true
          return
        }

        if( vApp.squareShop.optima > 0) {
          vApp.errorSquareShop_optima = false
          vApp.errorSquareShop_optimaText=''
        }
        else{
          vApp.errorSquareShop_optima = true
          vApp.errorSquareShop_optimaText='Поле обязательно к заполнению!'
          vApp.textSnackBar= `Неверно заполнена форма. Проверьте ошибочные поля`          
          vApp.snackbar=true
          return
        }

 /*       if( vApp.squareShop.includeTrade > 0) {
          vApp.errorSquareShop_includeTrade = false
          vApp.errorSquareShop_includeTradeText=''
        }
        else{
          vApp.errorSquareShop_includeTrade = true
          vApp.errorSquareShop_includeTradeText='Поле обязательно к заполнению!'
          vApp.textSnackBar= `Неверно заполнена форма. Проверьте ошибочные поля`          
          vApp.snackbar=true
          return
        }

        if( vApp.squareShop.includeWarehouse > 0) {
          vApp.errorSquareShop_includeWarehouse = false
          vApp.errorSquareShop_includeWarehouseText=''
        }
        else{
          vApp.errorSquareShop_includeWarehouse = true
          vApp.errorSquareShop_includeWarehouseText='Поле обязательно к заполнению!'
          vApp.textSnackBar= `Неверно заполнена форма. Проверьте ошибочные поля`
          vApp.snackbar=true
          return
        }

         if( vApp.squareShop.includeOffice > 0) {
          vApp.errorSquareShop_includeOffice = false
          vApp.errorSquareShop_includeOfficeText=''
        }
        else{
          vApp.errorSquareShop_includeOffice = true
          vApp.errorSquareShop_includeOfficeText='Поле обязательно к заполнению!'
          vApp.textSnackBar= `Неверно заполнена форма. Проверьте ошибочные поля`
          vApp.snackbar=true
          return
        } */

        if( vApp.contactsArenda.phones !== '') {
          vApp.errorPhone = false
          vApp.errorPhoneText=''
        }
        else{
          vApp.errorPhone = true
          vApp.errorPhoneText='Поле обязательно к заполнению!'
          vApp.textSnackBar= `Неверно заполнена форма. Проверьте ошибочные поля`
          vApp.snackbar=true
          return
        }

        if( vApp.contactsArenda.email !== '') {
          vApp.errorEmail = false
          vApp.errorEmailText=''
          if(DEBUG) console.log('rules :>> ', vApp.rules.email(vApp.contactsArenda.email));
         if( vApp.rules.email(vApp.contactsArenda.email) === 'Некорректный e-mail'){
           vApp.textSnackBar= `Неверно заполнена форма. Проверьте ошибочные поля`
           vApp.snackbar=true
           return
         }
        }
        else{
          vApp.errorEmail = true
          vApp.errorEmailText='Поле обязательно к заполнению!'
          vApp.textSnackBar= `Неверно заполнена форма. Проверьте ошибочные поля`
          vApp.snackbar=true
          return
        }
        
        if( vApp.contactsArenda.fio !== '') {
          vApp.errorFio = false
          vApp.errorFioText=''
        }
        else{
          vApp.errorFio = true
          vApp.errorFioText='Поле обязательно к заполнению!'
          vApp.textSnackBar= `Неверно заполнена форма. Проверьте ошибочные поля`
          vApp.snackbar=true
          return
        }
        if( vApp.chkPerson ) {
          vApp.errorCheckPerson = false
          //vApp.errorFioText=''
        }
        else{
          vApp.errorCheckPerson = true
          //vApp.errorFioText='Поле обязательно к заполнению!'
          vApp.textSnackBar= `Неверно заполнена форма. Проверьте ошибочные поля`
          vApp.snackbar=true
          return
        }


  let allDataInputs = null;
  allDataInputs = {
    valNameFirm: vApp.valNameFirm,
    valTradeProfile: vApp.valTradeProfile,
    valItemsProfile: vApp.valItemsProfile,
    tradeMarks: vApp.tradeMarks,
    numberOpenedShops: vApp.numberOpenedShops,
    otherTRC: vApp.otherTRC,
    squareShop: vApp.squareShop,
    contactsArenda: vApp.contactsArenda,    
    chkPerson: vApp.chkPerson,
  };
  if(DEBUG) console.log('send Form :>> ', allDataInputs);

        axios({
          method: "post",
            headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
              },
          url:
            "http://api.trcgagarinsky.ru/terminal__tmp/index.php/send/rent",
            data: allDataInputs
        })
          .catch(function (error) {
            // handle error
            if(DEBUG) console.log("ERROR send Form: ", error);
          })
          .then(function (response) {
            // handle success
            if(DEBUG) console.log("response send Form =", response.data);

            if(DEBUG) console.log('vApp.$refs :>> ', vApp.$refs)
            vApp.$refs.form.resetValidation()
            vApp.$refs.form.reset()
            vApp.textSnackBar= `Заявка отправлена. Спасибо`
            vApp.snackbar=true

          });
      

},

},
  mounted () {    
    
    let vApp = this
    this.$nextTick(function () {
      
      if(DEBUG) console.log('mounted Arenda');
      vApp.titleInnert = 'АРЕНДА';

      let scrollEl = document.querySelector('#scrollT');
      scrollEl.scrollTo(0,0);

    })

  },


};
</script>

<style scoped>
  .ymap-container {
  height: 400px;
}
</style>